import React, { useEffect, useState } from 'react';
import { getBonusCampaignTimeLeft } from '@homeplay/utils';
import { getBonusCampaignLabels } from './helpers';
import classes from './BonusCampaigns.module.scss';

export const useTimeLeft = (timestamp) => {
  const [timeLeft, setTimeLeft] = useState(() =>
    getBonusCampaignTimeLeft(timestamp)
  );

  useEffect(() => {
    if (!timestamp) return;

    setTimeLeft(getBonusCampaignTimeLeft(timestamp));
    const intervalId = setInterval(() => {
      setTimeLeft(getBonusCampaignTimeLeft(timestamp));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timestamp]);

  return timeLeft;
};

export const BonusCampaignLabels = ({ type }) => (
  <div className={classes.Labels}>
    {getBonusCampaignLabels(type).map(({ text, isPrimary }) => (
      <span
        key={text}
        className={
          classes.Label + (isPrimary ? ' button-primary' : ' ' + classes.Muted)
        }
      >
        {text}
      </span>
    ))}
  </div>
);

export const BonusCampaignProgress = ({ percentage = 0, isLarge = false }) => {
  const value = Math.min(100, Math.max(0, Math.floor(percentage)));

  return (
    <div className={classes.Progress + (isLarge ? ' ' + classes.Large : '')}>
      <div
        className={classes.ProgressTrack}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
      >
        <div
          className={classes.ProgressFill + ' button-primary'}
          style={{ width: `${value}%` }}
        />
      </div>
      <span className={classes.ProgressValue}>{value}%</span>
    </div>
  );
};
